import { render, staticRenderFns } from "./NotifyTable.vue?vue&type=template&id=a472442a&scoped=true"
import script from "./NotifyTable.vue?vue&type=script&lang=js"
export * from "./NotifyTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a472442a",
  null
  
)

export default component.exports